export const IPS_IDS = {
  NOX: "8d47ae32-912a-476f-929a-9d0d73ed3b9c",
  SOGAMOSO: "cdb54b4e-f9fc-4ca6-8850-e818e693789c",
};

export const PROCEDURE_IDS = {
  HYPERBARIC: "d110d833-b4d2-11ef-a5cd-066d180a3717",
  CORE: "8c868bfb-6d09-439d-af03-043883a9b8c9",
};

export const procedureIpsIdToGroup = {
  [`${PROCEDURE_IDS.HYPERBARIC}-${IPS_IDS.NOX}`]: "HYPERBARIC_FLOW_NOX",
  [`${PROCEDURE_IDS.CORE}-${IPS_IDS.NOX}`]: "CORE_NOX",
  [`${PROCEDURE_IDS.CORE}-${IPS_IDS.SOGAMOSO}`]: "CORE_SOGAMOSO",
};
